// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v1.181.2
//   protoc               v7.35.1
// source: identity.proto

/* eslint-disable */
import * as _m0 from "protobufjs/minimal";
import { Params } from "./common";

export const protobufPackage = "com.tick2trade.api.identity";

export enum AuthProvider {
  AUTH_PROVIDER_UNKNOWN = 0,
  GOOGLE = 1,
  X = 2,
  PASSWORD = 5,
  UNRECOGNIZED = -1,
}

export function authProviderFromJSON(object: any): AuthProvider {
  switch (object) {
    case 0:
    case "AUTH_PROVIDER_UNKNOWN":
      return AuthProvider.AUTH_PROVIDER_UNKNOWN;
    case 1:
    case "GOOGLE":
      return AuthProvider.GOOGLE;
    case 2:
    case "X":
      return AuthProvider.X;
    case 5:
    case "PASSWORD":
      return AuthProvider.PASSWORD;
    case -1:
    case "UNRECOGNIZED":
    default:
      return AuthProvider.UNRECOGNIZED;
  }
}

export function authProviderToJSON(object: AuthProvider): string {
  switch (object) {
    case AuthProvider.AUTH_PROVIDER_UNKNOWN:
      return "AUTH_PROVIDER_UNKNOWN";
    case AuthProvider.GOOGLE:
      return "GOOGLE";
    case AuthProvider.X:
      return "X";
    case AuthProvider.PASSWORD:
      return "PASSWORD";
    case AuthProvider.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum AuthProviderType {
  AUTH_PROVIDER_TYPE_UNKNOWN = 0,
  EMAIL_PROVIDER = 1,
  UNRECOGNIZED = -1,
}

export function authProviderTypeFromJSON(object: any): AuthProviderType {
  switch (object) {
    case 0:
    case "AUTH_PROVIDER_TYPE_UNKNOWN":
      return AuthProviderType.AUTH_PROVIDER_TYPE_UNKNOWN;
    case 1:
    case "EMAIL_PROVIDER":
      return AuthProviderType.EMAIL_PROVIDER;
    case -1:
    case "UNRECOGNIZED":
    default:
      return AuthProviderType.UNRECOGNIZED;
  }
}

export function authProviderTypeToJSON(object: AuthProviderType): string {
  switch (object) {
    case AuthProviderType.AUTH_PROVIDER_TYPE_UNKNOWN:
      return "AUTH_PROVIDER_TYPE_UNKNOWN";
    case AuthProviderType.EMAIL_PROVIDER:
      return "EMAIL_PROVIDER";
    case AuthProviderType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum PinVerificationChannel {
  PIN_VERIFICATION_CHANNEL_UNKNOWN = 0,
  PIN_VERIFICATION_CHANNEL_EMAIL = 1,
  PIN_VERIFICATION_CHANNEL_SMS = 2,
  UNRECOGNIZED = -1,
}

export function pinVerificationChannelFromJSON(object: any): PinVerificationChannel {
  switch (object) {
    case 0:
    case "PIN_VERIFICATION_CHANNEL_UNKNOWN":
      return PinVerificationChannel.PIN_VERIFICATION_CHANNEL_UNKNOWN;
    case 1:
    case "PIN_VERIFICATION_CHANNEL_EMAIL":
      return PinVerificationChannel.PIN_VERIFICATION_CHANNEL_EMAIL;
    case 2:
    case "PIN_VERIFICATION_CHANNEL_SMS":
      return PinVerificationChannel.PIN_VERIFICATION_CHANNEL_SMS;
    case -1:
    case "UNRECOGNIZED":
    default:
      return PinVerificationChannel.UNRECOGNIZED;
  }
}

export function pinVerificationChannelToJSON(object: PinVerificationChannel): string {
  switch (object) {
    case PinVerificationChannel.PIN_VERIFICATION_CHANNEL_UNKNOWN:
      return "PIN_VERIFICATION_CHANNEL_UNKNOWN";
    case PinVerificationChannel.PIN_VERIFICATION_CHANNEL_EMAIL:
      return "PIN_VERIFICATION_CHANNEL_EMAIL";
    case PinVerificationChannel.PIN_VERIFICATION_CHANNEL_SMS:
      return "PIN_VERIFICATION_CHANNEL_SMS";
    case PinVerificationChannel.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum Role {
  ADMIN = 0,
  USER = 1,
  UNRECOGNIZED = -1,
}

export function roleFromJSON(object: any): Role {
  switch (object) {
    case 0:
    case "ADMIN":
      return Role.ADMIN;
    case 1:
    case "USER":
      return Role.USER;
    case -1:
    case "UNRECOGNIZED":
    default:
      return Role.UNRECOGNIZED;
  }
}

export function roleToJSON(object: Role): string {
  switch (object) {
    case Role.ADMIN:
      return "ADMIN";
    case Role.USER:
      return "USER";
    case Role.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface User {
  id: string;
  email: string;
  name: string;
  avatarUrl: string;
  provider: AuthProvider;
  providerUserId: string;
  status: User_Status;
  countryCode: string;
  mobile: string;
  mobileVerified: boolean;
  attributes: string;
  preferences: string;
  authorities: string[];
  subscriptionPlans: string[];
  isPinEnabled: boolean;
}

export enum User_Status {
  STATUS_UNKNOWN = 0,
  ACTIVE = 1,
  WAIT_LISTED = 2,
  BLOCKED = 3,
  UNRECOGNIZED = -1,
}

export function user_StatusFromJSON(object: any): User_Status {
  switch (object) {
    case 0:
    case "STATUS_UNKNOWN":
      return User_Status.STATUS_UNKNOWN;
    case 1:
    case "ACTIVE":
      return User_Status.ACTIVE;
    case 2:
    case "WAIT_LISTED":
      return User_Status.WAIT_LISTED;
    case 3:
    case "BLOCKED":
      return User_Status.BLOCKED;
    case -1:
    case "UNRECOGNIZED":
    default:
      return User_Status.UNRECOGNIZED;
  }
}

export function user_StatusToJSON(object: User_Status): string {
  switch (object) {
    case User_Status.STATUS_UNKNOWN:
      return "STATUS_UNKNOWN";
    case User_Status.ACTIVE:
      return "ACTIVE";
    case User_Status.WAIT_LISTED:
      return "WAIT_LISTED";
    case User_Status.BLOCKED:
      return "BLOCKED";
    case User_Status.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface Users {
  users: User[];
}

export interface ThirdPartyLoginProvider {
  code: string;
  redirectUrl: string;
  validateUrl: string;
  type: ThirdPartyLoginProvider_Type;
}

export enum ThirdPartyLoginProvider_Type {
  LOGIN_PROVIDER_UNKNOWN = 0,
  EMAIL_PROVIDER = 1,
  BROKER = 2,
  UNRECOGNIZED = -1,
}

export function thirdPartyLoginProvider_TypeFromJSON(object: any): ThirdPartyLoginProvider_Type {
  switch (object) {
    case 0:
    case "LOGIN_PROVIDER_UNKNOWN":
      return ThirdPartyLoginProvider_Type.LOGIN_PROVIDER_UNKNOWN;
    case 1:
    case "EMAIL_PROVIDER":
      return ThirdPartyLoginProvider_Type.EMAIL_PROVIDER;
    case 2:
    case "BROKER":
      return ThirdPartyLoginProvider_Type.BROKER;
    case -1:
    case "UNRECOGNIZED":
    default:
      return ThirdPartyLoginProvider_Type.UNRECOGNIZED;
  }
}

export function thirdPartyLoginProvider_TypeToJSON(object: ThirdPartyLoginProvider_Type): string {
  switch (object) {
    case ThirdPartyLoginProvider_Type.LOGIN_PROVIDER_UNKNOWN:
      return "LOGIN_PROVIDER_UNKNOWN";
    case ThirdPartyLoginProvider_Type.EMAIL_PROVIDER:
      return "EMAIL_PROVIDER";
    case ThirdPartyLoginProvider_Type.BROKER:
      return "BROKER";
    case ThirdPartyLoginProvider_Type.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface ValidateTokenResponse {
  user: User | undefined;
}

export interface AuthProviderLoginUrlRequest {
  authProvider: AuthProvider;
  params: Params[];
}

export interface AuthProviderLoginUrlResponse {
  authProvider: AuthProvider;
  url: string;
  redirectParamsKey: string;
}

export interface ValidateThirdPartyTokenRequest {
  authProvider: AuthProvider;
  tokenInfo: ValidateThirdPartyTokenRequest_TokenInfo[];
  deviceId: string;
  deviceInfo: string;
}

export interface ValidateThirdPartyTokenRequest_TokenInfo {
  key: string;
  value: string;
}

export interface AddMobileNumberRequest {
  countryCode: string;
  mobileNumber: string;
  pin: string;
}

export interface AddMobileNumberResponse {
  verificationRequired: boolean;
  user: User | undefined;
  requestId: string;
}

export interface ResendVerificationCodeResponse {
  requestId: string;
}

export interface VerifyMobileNumberRequest {
  verificationCode: string;
  requestId: string;
}

export interface VerifyMobileNumberResponse {
  successful: boolean;
  user: User | undefined;
  pinSetupToken: string;
}

export interface UserSignUpRequest {
  name: string;
  email: string;
  password: string;
  emailVerificationRequestId: string;
  emailVerificationOtp: string;
  deviceId: string;
}

export interface ForgetPasswordRequest {
  email: string;
  newPassword: string;
  emailVerificationRequestId: string;
  emailVerificationOtp: string;
}

export interface SendEmailOtpResponse {
  requestId: string;
}

export interface VerifyEmailOtpRequest {
  email: string;
  requestId: string;
  verificationOtp: string;
}

export interface VerifyEmailOtpResponse {
  successful: boolean;
}

export interface ChangeEmailRequest {
  newEmail: string;
  pin: string;
}

export interface VerifyEmailChangeRequest {
  newEmail: string;
  requestId: string;
  verificationOtp: string;
}

export interface LoginRequest {
  email: string;
  password: string;
  deviceId: string;
  deviceInfo: string;
}

export interface LoginWithMobileRequest {
  mobile: string;
}

export interface LoginWithMobileResponse {
  requestId: string;
}

export interface VerifyMobileLoginRequest {
  mobile: string;
  requestId: string;
  verificationOtp: string;
  deviceId: string;
  deviceInfo: string;
}

export interface LoginResponse {
  accessToken: string;
  tokenType: string;
  isNewUser?: boolean | undefined;
  refreshToken: string;
}

export interface SessionRequest {
  refreshToken: string;
  deviceId: string;
  deviceInfo: string;
}

export interface RefreshTokenResponse {
  accessToken: string;
  tokenType: string;
}

export interface OperationResponse {
  success: boolean;
  message: string;
  /** Set when PIN unlock / setup / forgot-PIN remints an unlocked access token. */
  accessToken: string;
}

export interface UserSession {
  deviceId: string;
  lastUsedAt: string;
  deviceInfo: string;
}

export interface GetActiveSessionsResponse {
  sessions: UserSession[];
}

export interface RevokeSessionRequest {
  deviceId: string;
}

export interface SendPinVerificationOtpRequest {
  channel: PinVerificationChannel;
}

export interface SendPinVerificationOtpResponse {
  requestId: string;
}

export interface SetPinRequest {
  pin: string;
  verificationRequestId: string;
  verificationOtp: string;
  pinSetupToken: string;
}

export interface VerifyPinRequest {
  pin: string;
}

export interface RemovePinRequest {
  verificationRequestId: string;
  verificationOtp: string;
}

export interface SendForgotPinOtpResponse {
  /** Single OTP delivered to both email and mobile. */
  requestId: string;
}

export interface ForgotPinRequest {
  newPin: string;
  verificationRequestId: string;
  verificationOtp: string;
}

function createBaseUser(): User {
  return {
    id: "",
    email: "",
    name: "",
    avatarUrl: "",
    provider: 0,
    providerUserId: "",
    status: 0,
    countryCode: "",
    mobile: "",
    mobileVerified: false,
    attributes: "",
    preferences: "",
    authorities: [],
    subscriptionPlans: [],
    isPinEnabled: false,
  };
}

export const User = {
  encode(message: User, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.email !== "") {
      writer.uint32(18).string(message.email);
    }
    if (message.name !== "") {
      writer.uint32(34).string(message.name);
    }
    if (message.avatarUrl !== "") {
      writer.uint32(50).string(message.avatarUrl);
    }
    if (message.provider !== 0) {
      writer.uint32(64).int32(message.provider);
    }
    if (message.providerUserId !== "") {
      writer.uint32(82).string(message.providerUserId);
    }
    if (message.status !== 0) {
      writer.uint32(96).int32(message.status);
    }
    if (message.countryCode !== "") {
      writer.uint32(106).string(message.countryCode);
    }
    if (message.mobile !== "") {
      writer.uint32(114).string(message.mobile);
    }
    if (message.mobileVerified !== false) {
      writer.uint32(128).bool(message.mobileVerified);
    }
    if (message.attributes !== "") {
      writer.uint32(146).string(message.attributes);
    }
    if (message.preferences !== "") {
      writer.uint32(162).string(message.preferences);
    }
    for (const v of message.authorities) {
      writer.uint32(170).string(v!);
    }
    for (const v of message.subscriptionPlans) {
      writer.uint32(186).string(v!);
    }
    if (message.isPinEnabled !== false) {
      writer.uint32(192).bool(message.isPinEnabled);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): User {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUser();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.email = reader.string();
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.name = reader.string();
          continue;
        case 6:
          if (tag !== 50) {
            break;
          }

          message.avatarUrl = reader.string();
          continue;
        case 8:
          if (tag !== 64) {
            break;
          }

          message.provider = reader.int32() as any;
          continue;
        case 10:
          if (tag !== 82) {
            break;
          }

          message.providerUserId = reader.string();
          continue;
        case 12:
          if (tag !== 96) {
            break;
          }

          message.status = reader.int32() as any;
          continue;
        case 13:
          if (tag !== 106) {
            break;
          }

          message.countryCode = reader.string();
          continue;
        case 14:
          if (tag !== 114) {
            break;
          }

          message.mobile = reader.string();
          continue;
        case 16:
          if (tag !== 128) {
            break;
          }

          message.mobileVerified = reader.bool();
          continue;
        case 18:
          if (tag !== 146) {
            break;
          }

          message.attributes = reader.string();
          continue;
        case 20:
          if (tag !== 162) {
            break;
          }

          message.preferences = reader.string();
          continue;
        case 21:
          if (tag !== 170) {
            break;
          }

          message.authorities.push(reader.string());
          continue;
        case 23:
          if (tag !== 186) {
            break;
          }

          message.subscriptionPlans.push(reader.string());
          continue;
        case 24:
          if (tag !== 192) {
            break;
          }

          message.isPinEnabled = reader.bool();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): User {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      email: isSet(object.email) ? globalThis.String(object.email) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      avatarUrl: isSet(object.avatarUrl) ? globalThis.String(object.avatarUrl) : "",
      provider: isSet(object.provider) ? authProviderFromJSON(object.provider) : 0,
      providerUserId: isSet(object.providerUserId) ? globalThis.String(object.providerUserId) : "",
      status: isSet(object.status) ? user_StatusFromJSON(object.status) : 0,
      countryCode: isSet(object.countryCode) ? globalThis.String(object.countryCode) : "",
      mobile: isSet(object.mobile) ? globalThis.String(object.mobile) : "",
      mobileVerified: isSet(object.mobileVerified) ? globalThis.Boolean(object.mobileVerified) : false,
      attributes: isSet(object.attributes) ? globalThis.String(object.attributes) : "",
      preferences: isSet(object.preferences) ? globalThis.String(object.preferences) : "",
      authorities: globalThis.Array.isArray(object?.authorities)
        ? object.authorities.map((e: any) => globalThis.String(e))
        : [],
      subscriptionPlans: globalThis.Array.isArray(object?.subscriptionPlans)
        ? object.subscriptionPlans.map((e: any) => globalThis.String(e))
        : [],
      isPinEnabled: isSet(object.isPinEnabled) ? globalThis.Boolean(object.isPinEnabled) : false,
    };
  },

  toJSON(message: User): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.email !== "") {
      obj.email = message.email;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.avatarUrl !== "") {
      obj.avatarUrl = message.avatarUrl;
    }
    if (message.provider !== 0) {
      obj.provider = authProviderToJSON(message.provider);
    }
    if (message.providerUserId !== "") {
      obj.providerUserId = message.providerUserId;
    }
    if (message.status !== 0) {
      obj.status = user_StatusToJSON(message.status);
    }
    if (message.countryCode !== "") {
      obj.countryCode = message.countryCode;
    }
    if (message.mobile !== "") {
      obj.mobile = message.mobile;
    }
    if (message.mobileVerified !== false) {
      obj.mobileVerified = message.mobileVerified;
    }
    if (message.attributes !== "") {
      obj.attributes = message.attributes;
    }
    if (message.preferences !== "") {
      obj.preferences = message.preferences;
    }
    if (message.authorities?.length) {
      obj.authorities = message.authorities;
    }
    if (message.subscriptionPlans?.length) {
      obj.subscriptionPlans = message.subscriptionPlans;
    }
    if (message.isPinEnabled !== false) {
      obj.isPinEnabled = message.isPinEnabled;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<User>, I>>(base?: I): User {
    return User.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<User>, I>>(object: I): User {
    const message = createBaseUser();
    message.id = object.id ?? "";
    message.email = object.email ?? "";
    message.name = object.name ?? "";
    message.avatarUrl = object.avatarUrl ?? "";
    message.provider = object.provider ?? 0;
    message.providerUserId = object.providerUserId ?? "";
    message.status = object.status ?? 0;
    message.countryCode = object.countryCode ?? "";
    message.mobile = object.mobile ?? "";
    message.mobileVerified = object.mobileVerified ?? false;
    message.attributes = object.attributes ?? "";
    message.preferences = object.preferences ?? "";
    message.authorities = object.authorities?.map((e) => e) || [];
    message.subscriptionPlans = object.subscriptionPlans?.map((e) => e) || [];
    message.isPinEnabled = object.isPinEnabled ?? false;
    return message;
  },
};

function createBaseUsers(): Users {
  return { users: [] };
}

export const Users = {
  encode(message: Users, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    for (const v of message.users) {
      User.encode(v!, writer.uint32(10).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): Users {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUsers();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.users.push(User.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Users {
    return { users: globalThis.Array.isArray(object?.users) ? object.users.map((e: any) => User.fromJSON(e)) : [] };
  },

  toJSON(message: Users): unknown {
    const obj: any = {};
    if (message.users?.length) {
      obj.users = message.users.map((e) => User.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Users>, I>>(base?: I): Users {
    return Users.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Users>, I>>(object: I): Users {
    const message = createBaseUsers();
    message.users = object.users?.map((e) => User.fromPartial(e)) || [];
    return message;
  },
};

function createBaseThirdPartyLoginProvider(): ThirdPartyLoginProvider {
  return { code: "", redirectUrl: "", validateUrl: "", type: 0 };
}

export const ThirdPartyLoginProvider = {
  encode(message: ThirdPartyLoginProvider, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.code !== "") {
      writer.uint32(10).string(message.code);
    }
    if (message.redirectUrl !== "") {
      writer.uint32(18).string(message.redirectUrl);
    }
    if (message.validateUrl !== "") {
      writer.uint32(26).string(message.validateUrl);
    }
    if (message.type !== 0) {
      writer.uint32(32).int32(message.type);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): ThirdPartyLoginProvider {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseThirdPartyLoginProvider();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.code = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.redirectUrl = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.validateUrl = reader.string();
          continue;
        case 4:
          if (tag !== 32) {
            break;
          }

          message.type = reader.int32() as any;
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ThirdPartyLoginProvider {
    return {
      code: isSet(object.code) ? globalThis.String(object.code) : "",
      redirectUrl: isSet(object.redirectUrl) ? globalThis.String(object.redirectUrl) : "",
      validateUrl: isSet(object.validateUrl) ? globalThis.String(object.validateUrl) : "",
      type: isSet(object.type) ? thirdPartyLoginProvider_TypeFromJSON(object.type) : 0,
    };
  },

  toJSON(message: ThirdPartyLoginProvider): unknown {
    const obj: any = {};
    if (message.code !== "") {
      obj.code = message.code;
    }
    if (message.redirectUrl !== "") {
      obj.redirectUrl = message.redirectUrl;
    }
    if (message.validateUrl !== "") {
      obj.validateUrl = message.validateUrl;
    }
    if (message.type !== 0) {
      obj.type = thirdPartyLoginProvider_TypeToJSON(message.type);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ThirdPartyLoginProvider>, I>>(base?: I): ThirdPartyLoginProvider {
    return ThirdPartyLoginProvider.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ThirdPartyLoginProvider>, I>>(object: I): ThirdPartyLoginProvider {
    const message = createBaseThirdPartyLoginProvider();
    message.code = object.code ?? "";
    message.redirectUrl = object.redirectUrl ?? "";
    message.validateUrl = object.validateUrl ?? "";
    message.type = object.type ?? 0;
    return message;
  },
};

function createBaseValidateTokenResponse(): ValidateTokenResponse {
  return { user: undefined };
}

export const ValidateTokenResponse = {
  encode(message: ValidateTokenResponse, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.user !== undefined) {
      User.encode(message.user, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): ValidateTokenResponse {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseValidateTokenResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2:
          if (tag !== 18) {
            break;
          }

          message.user = User.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ValidateTokenResponse {
    return { user: isSet(object.user) ? User.fromJSON(object.user) : undefined };
  },

  toJSON(message: ValidateTokenResponse): unknown {
    const obj: any = {};
    if (message.user !== undefined) {
      obj.user = User.toJSON(message.user);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ValidateTokenResponse>, I>>(base?: I): ValidateTokenResponse {
    return ValidateTokenResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ValidateTokenResponse>, I>>(object: I): ValidateTokenResponse {
    const message = createBaseValidateTokenResponse();
    message.user = (object.user !== undefined && object.user !== null) ? User.fromPartial(object.user) : undefined;
    return message;
  },
};

function createBaseAuthProviderLoginUrlRequest(): AuthProviderLoginUrlRequest {
  return { authProvider: 0, params: [] };
}

export const AuthProviderLoginUrlRequest = {
  encode(message: AuthProviderLoginUrlRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.authProvider !== 0) {
      writer.uint32(8).int32(message.authProvider);
    }
    for (const v of message.params) {
      Params.encode(v!, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): AuthProviderLoginUrlRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAuthProviderLoginUrlRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.authProvider = reader.int32() as any;
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.params.push(Params.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AuthProviderLoginUrlRequest {
    return {
      authProvider: isSet(object.authProvider) ? authProviderFromJSON(object.authProvider) : 0,
      params: globalThis.Array.isArray(object?.params) ? object.params.map((e: any) => Params.fromJSON(e)) : [],
    };
  },

  toJSON(message: AuthProviderLoginUrlRequest): unknown {
    const obj: any = {};
    if (message.authProvider !== 0) {
      obj.authProvider = authProviderToJSON(message.authProvider);
    }
    if (message.params?.length) {
      obj.params = message.params.map((e) => Params.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AuthProviderLoginUrlRequest>, I>>(base?: I): AuthProviderLoginUrlRequest {
    return AuthProviderLoginUrlRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AuthProviderLoginUrlRequest>, I>>(object: I): AuthProviderLoginUrlRequest {
    const message = createBaseAuthProviderLoginUrlRequest();
    message.authProvider = object.authProvider ?? 0;
    message.params = object.params?.map((e) => Params.fromPartial(e)) || [];
    return message;
  },
};

function createBaseAuthProviderLoginUrlResponse(): AuthProviderLoginUrlResponse {
  return { authProvider: 0, url: "", redirectParamsKey: "" };
}

export const AuthProviderLoginUrlResponse = {
  encode(message: AuthProviderLoginUrlResponse, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.authProvider !== 0) {
      writer.uint32(8).int32(message.authProvider);
    }
    if (message.url !== "") {
      writer.uint32(18).string(message.url);
    }
    if (message.redirectParamsKey !== "") {
      writer.uint32(26).string(message.redirectParamsKey);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): AuthProviderLoginUrlResponse {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAuthProviderLoginUrlResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.authProvider = reader.int32() as any;
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.url = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.redirectParamsKey = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AuthProviderLoginUrlResponse {
    return {
      authProvider: isSet(object.authProvider) ? authProviderFromJSON(object.authProvider) : 0,
      url: isSet(object.url) ? globalThis.String(object.url) : "",
      redirectParamsKey: isSet(object.redirectParamsKey) ? globalThis.String(object.redirectParamsKey) : "",
    };
  },

  toJSON(message: AuthProviderLoginUrlResponse): unknown {
    const obj: any = {};
    if (message.authProvider !== 0) {
      obj.authProvider = authProviderToJSON(message.authProvider);
    }
    if (message.url !== "") {
      obj.url = message.url;
    }
    if (message.redirectParamsKey !== "") {
      obj.redirectParamsKey = message.redirectParamsKey;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AuthProviderLoginUrlResponse>, I>>(base?: I): AuthProviderLoginUrlResponse {
    return AuthProviderLoginUrlResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AuthProviderLoginUrlResponse>, I>>(object: I): AuthProviderLoginUrlResponse {
    const message = createBaseAuthProviderLoginUrlResponse();
    message.authProvider = object.authProvider ?? 0;
    message.url = object.url ?? "";
    message.redirectParamsKey = object.redirectParamsKey ?? "";
    return message;
  },
};

function createBaseValidateThirdPartyTokenRequest(): ValidateThirdPartyTokenRequest {
  return { authProvider: 0, tokenInfo: [], deviceId: "", deviceInfo: "" };
}

export const ValidateThirdPartyTokenRequest = {
  encode(message: ValidateThirdPartyTokenRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.authProvider !== 0) {
      writer.uint32(16).int32(message.authProvider);
    }
    for (const v of message.tokenInfo) {
      ValidateThirdPartyTokenRequest_TokenInfo.encode(v!, writer.uint32(10).fork()).ldelim();
    }
    if (message.deviceId !== "") {
      writer.uint32(26).string(message.deviceId);
    }
    if (message.deviceInfo !== "") {
      writer.uint32(34).string(message.deviceInfo);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): ValidateThirdPartyTokenRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseValidateThirdPartyTokenRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2:
          if (tag !== 16) {
            break;
          }

          message.authProvider = reader.int32() as any;
          continue;
        case 1:
          if (tag !== 10) {
            break;
          }

          message.tokenInfo.push(ValidateThirdPartyTokenRequest_TokenInfo.decode(reader, reader.uint32()));
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.deviceId = reader.string();
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.deviceInfo = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ValidateThirdPartyTokenRequest {
    return {
      authProvider: isSet(object.authProvider) ? authProviderFromJSON(object.authProvider) : 0,
      tokenInfo: globalThis.Array.isArray(object?.tokenInfo)
        ? object.tokenInfo.map((e: any) => ValidateThirdPartyTokenRequest_TokenInfo.fromJSON(e))
        : [],
      deviceId: isSet(object.deviceId) ? globalThis.String(object.deviceId) : "",
      deviceInfo: isSet(object.deviceInfo) ? globalThis.String(object.deviceInfo) : "",
    };
  },

  toJSON(message: ValidateThirdPartyTokenRequest): unknown {
    const obj: any = {};
    if (message.authProvider !== 0) {
      obj.authProvider = authProviderToJSON(message.authProvider);
    }
    if (message.tokenInfo?.length) {
      obj.tokenInfo = message.tokenInfo.map((e) => ValidateThirdPartyTokenRequest_TokenInfo.toJSON(e));
    }
    if (message.deviceId !== "") {
      obj.deviceId = message.deviceId;
    }
    if (message.deviceInfo !== "") {
      obj.deviceInfo = message.deviceInfo;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ValidateThirdPartyTokenRequest>, I>>(base?: I): ValidateThirdPartyTokenRequest {
    return ValidateThirdPartyTokenRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ValidateThirdPartyTokenRequest>, I>>(
    object: I,
  ): ValidateThirdPartyTokenRequest {
    const message = createBaseValidateThirdPartyTokenRequest();
    message.authProvider = object.authProvider ?? 0;
    message.tokenInfo = object.tokenInfo?.map((e) => ValidateThirdPartyTokenRequest_TokenInfo.fromPartial(e)) || [];
    message.deviceId = object.deviceId ?? "";
    message.deviceInfo = object.deviceInfo ?? "";
    return message;
  },
};

function createBaseValidateThirdPartyTokenRequest_TokenInfo(): ValidateThirdPartyTokenRequest_TokenInfo {
  return { key: "", value: "" };
}

export const ValidateThirdPartyTokenRequest_TokenInfo = {
  encode(message: ValidateThirdPartyTokenRequest_TokenInfo, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== "") {
      writer.uint32(18).string(message.value);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): ValidateThirdPartyTokenRequest_TokenInfo {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseValidateThirdPartyTokenRequest_TokenInfo();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.value = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ValidateThirdPartyTokenRequest_TokenInfo {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? globalThis.String(object.value) : "",
    };
  },

  toJSON(message: ValidateThirdPartyTokenRequest_TokenInfo): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== "") {
      obj.value = message.value;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ValidateThirdPartyTokenRequest_TokenInfo>, I>>(
    base?: I,
  ): ValidateThirdPartyTokenRequest_TokenInfo {
    return ValidateThirdPartyTokenRequest_TokenInfo.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ValidateThirdPartyTokenRequest_TokenInfo>, I>>(
    object: I,
  ): ValidateThirdPartyTokenRequest_TokenInfo {
    const message = createBaseValidateThirdPartyTokenRequest_TokenInfo();
    message.key = object.key ?? "";
    message.value = object.value ?? "";
    return message;
  },
};

function createBaseAddMobileNumberRequest(): AddMobileNumberRequest {
  return { countryCode: "", mobileNumber: "", pin: "" };
}

export const AddMobileNumberRequest = {
  encode(message: AddMobileNumberRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.countryCode !== "") {
      writer.uint32(10).string(message.countryCode);
    }
    if (message.mobileNumber !== "") {
      writer.uint32(18).string(message.mobileNumber);
    }
    if (message.pin !== "") {
      writer.uint32(26).string(message.pin);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): AddMobileNumberRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAddMobileNumberRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.countryCode = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.mobileNumber = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.pin = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AddMobileNumberRequest {
    return {
      countryCode: isSet(object.countryCode) ? globalThis.String(object.countryCode) : "",
      mobileNumber: isSet(object.mobileNumber) ? globalThis.String(object.mobileNumber) : "",
      pin: isSet(object.pin) ? globalThis.String(object.pin) : "",
    };
  },

  toJSON(message: AddMobileNumberRequest): unknown {
    const obj: any = {};
    if (message.countryCode !== "") {
      obj.countryCode = message.countryCode;
    }
    if (message.mobileNumber !== "") {
      obj.mobileNumber = message.mobileNumber;
    }
    if (message.pin !== "") {
      obj.pin = message.pin;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AddMobileNumberRequest>, I>>(base?: I): AddMobileNumberRequest {
    return AddMobileNumberRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AddMobileNumberRequest>, I>>(object: I): AddMobileNumberRequest {
    const message = createBaseAddMobileNumberRequest();
    message.countryCode = object.countryCode ?? "";
    message.mobileNumber = object.mobileNumber ?? "";
    message.pin = object.pin ?? "";
    return message;
  },
};

function createBaseAddMobileNumberResponse(): AddMobileNumberResponse {
  return { verificationRequired: false, user: undefined, requestId: "" };
}

export const AddMobileNumberResponse = {
  encode(message: AddMobileNumberResponse, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.verificationRequired !== false) {
      writer.uint32(8).bool(message.verificationRequired);
    }
    if (message.user !== undefined) {
      User.encode(message.user, writer.uint32(18).fork()).ldelim();
    }
    if (message.requestId !== "") {
      writer.uint32(26).string(message.requestId);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): AddMobileNumberResponse {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAddMobileNumberResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.verificationRequired = reader.bool();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.user = User.decode(reader, reader.uint32());
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.requestId = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AddMobileNumberResponse {
    return {
      verificationRequired: isSet(object.verificationRequired)
        ? globalThis.Boolean(object.verificationRequired)
        : false,
      user: isSet(object.user) ? User.fromJSON(object.user) : undefined,
      requestId: isSet(object.requestId) ? globalThis.String(object.requestId) : "",
    };
  },

  toJSON(message: AddMobileNumberResponse): unknown {
    const obj: any = {};
    if (message.verificationRequired !== false) {
      obj.verificationRequired = message.verificationRequired;
    }
    if (message.user !== undefined) {
      obj.user = User.toJSON(message.user);
    }
    if (message.requestId !== "") {
      obj.requestId = message.requestId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AddMobileNumberResponse>, I>>(base?: I): AddMobileNumberResponse {
    return AddMobileNumberResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AddMobileNumberResponse>, I>>(object: I): AddMobileNumberResponse {
    const message = createBaseAddMobileNumberResponse();
    message.verificationRequired = object.verificationRequired ?? false;
    message.user = (object.user !== undefined && object.user !== null) ? User.fromPartial(object.user) : undefined;
    message.requestId = object.requestId ?? "";
    return message;
  },
};

function createBaseResendVerificationCodeResponse(): ResendVerificationCodeResponse {
  return { requestId: "" };
}

export const ResendVerificationCodeResponse = {
  encode(message: ResendVerificationCodeResponse, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.requestId !== "") {
      writer.uint32(10).string(message.requestId);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): ResendVerificationCodeResponse {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseResendVerificationCodeResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.requestId = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ResendVerificationCodeResponse {
    return { requestId: isSet(object.requestId) ? globalThis.String(object.requestId) : "" };
  },

  toJSON(message: ResendVerificationCodeResponse): unknown {
    const obj: any = {};
    if (message.requestId !== "") {
      obj.requestId = message.requestId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ResendVerificationCodeResponse>, I>>(base?: I): ResendVerificationCodeResponse {
    return ResendVerificationCodeResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ResendVerificationCodeResponse>, I>>(
    object: I,
  ): ResendVerificationCodeResponse {
    const message = createBaseResendVerificationCodeResponse();
    message.requestId = object.requestId ?? "";
    return message;
  },
};

function createBaseVerifyMobileNumberRequest(): VerifyMobileNumberRequest {
  return { verificationCode: "", requestId: "" };
}

export const VerifyMobileNumberRequest = {
  encode(message: VerifyMobileNumberRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.verificationCode !== "") {
      writer.uint32(10).string(message.verificationCode);
    }
    if (message.requestId !== "") {
      writer.uint32(18).string(message.requestId);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): VerifyMobileNumberRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseVerifyMobileNumberRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.verificationCode = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.requestId = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): VerifyMobileNumberRequest {
    return {
      verificationCode: isSet(object.verificationCode) ? globalThis.String(object.verificationCode) : "",
      requestId: isSet(object.requestId) ? globalThis.String(object.requestId) : "",
    };
  },

  toJSON(message: VerifyMobileNumberRequest): unknown {
    const obj: any = {};
    if (message.verificationCode !== "") {
      obj.verificationCode = message.verificationCode;
    }
    if (message.requestId !== "") {
      obj.requestId = message.requestId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<VerifyMobileNumberRequest>, I>>(base?: I): VerifyMobileNumberRequest {
    return VerifyMobileNumberRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<VerifyMobileNumberRequest>, I>>(object: I): VerifyMobileNumberRequest {
    const message = createBaseVerifyMobileNumberRequest();
    message.verificationCode = object.verificationCode ?? "";
    message.requestId = object.requestId ?? "";
    return message;
  },
};

function createBaseVerifyMobileNumberResponse(): VerifyMobileNumberResponse {
  return { successful: false, user: undefined, pinSetupToken: "" };
}

export const VerifyMobileNumberResponse = {
  encode(message: VerifyMobileNumberResponse, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.successful !== false) {
      writer.uint32(8).bool(message.successful);
    }
    if (message.user !== undefined) {
      User.encode(message.user, writer.uint32(18).fork()).ldelim();
    }
    if (message.pinSetupToken !== "") {
      writer.uint32(26).string(message.pinSetupToken);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): VerifyMobileNumberResponse {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseVerifyMobileNumberResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.successful = reader.bool();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.user = User.decode(reader, reader.uint32());
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.pinSetupToken = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): VerifyMobileNumberResponse {
    return {
      successful: isSet(object.successful) ? globalThis.Boolean(object.successful) : false,
      user: isSet(object.user) ? User.fromJSON(object.user) : undefined,
      pinSetupToken: isSet(object.pinSetupToken) ? globalThis.String(object.pinSetupToken) : "",
    };
  },

  toJSON(message: VerifyMobileNumberResponse): unknown {
    const obj: any = {};
    if (message.successful !== false) {
      obj.successful = message.successful;
    }
    if (message.user !== undefined) {
      obj.user = User.toJSON(message.user);
    }
    if (message.pinSetupToken !== "") {
      obj.pinSetupToken = message.pinSetupToken;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<VerifyMobileNumberResponse>, I>>(base?: I): VerifyMobileNumberResponse {
    return VerifyMobileNumberResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<VerifyMobileNumberResponse>, I>>(object: I): VerifyMobileNumberResponse {
    const message = createBaseVerifyMobileNumberResponse();
    message.successful = object.successful ?? false;
    message.user = (object.user !== undefined && object.user !== null) ? User.fromPartial(object.user) : undefined;
    message.pinSetupToken = object.pinSetupToken ?? "";
    return message;
  },
};

function createBaseUserSignUpRequest(): UserSignUpRequest {
  return { name: "", email: "", password: "", emailVerificationRequestId: "", emailVerificationOtp: "", deviceId: "" };
}

export const UserSignUpRequest = {
  encode(message: UserSignUpRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.name !== "") {
      writer.uint32(10).string(message.name);
    }
    if (message.email !== "") {
      writer.uint32(18).string(message.email);
    }
    if (message.password !== "") {
      writer.uint32(26).string(message.password);
    }
    if (message.emailVerificationRequestId !== "") {
      writer.uint32(34).string(message.emailVerificationRequestId);
    }
    if (message.emailVerificationOtp !== "") {
      writer.uint32(42).string(message.emailVerificationOtp);
    }
    if (message.deviceId !== "") {
      writer.uint32(50).string(message.deviceId);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): UserSignUpRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUserSignUpRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.name = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.email = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.password = reader.string();
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.emailVerificationRequestId = reader.string();
          continue;
        case 5:
          if (tag !== 42) {
            break;
          }

          message.emailVerificationOtp = reader.string();
          continue;
        case 6:
          if (tag !== 50) {
            break;
          }

          message.deviceId = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UserSignUpRequest {
    return {
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      email: isSet(object.email) ? globalThis.String(object.email) : "",
      password: isSet(object.password) ? globalThis.String(object.password) : "",
      emailVerificationRequestId: isSet(object.emailVerificationRequestId)
        ? globalThis.String(object.emailVerificationRequestId)
        : "",
      emailVerificationOtp: isSet(object.emailVerificationOtp) ? globalThis.String(object.emailVerificationOtp) : "",
      deviceId: isSet(object.deviceId) ? globalThis.String(object.deviceId) : "",
    };
  },

  toJSON(message: UserSignUpRequest): unknown {
    const obj: any = {};
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.email !== "") {
      obj.email = message.email;
    }
    if (message.password !== "") {
      obj.password = message.password;
    }
    if (message.emailVerificationRequestId !== "") {
      obj.emailVerificationRequestId = message.emailVerificationRequestId;
    }
    if (message.emailVerificationOtp !== "") {
      obj.emailVerificationOtp = message.emailVerificationOtp;
    }
    if (message.deviceId !== "") {
      obj.deviceId = message.deviceId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UserSignUpRequest>, I>>(base?: I): UserSignUpRequest {
    return UserSignUpRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UserSignUpRequest>, I>>(object: I): UserSignUpRequest {
    const message = createBaseUserSignUpRequest();
    message.name = object.name ?? "";
    message.email = object.email ?? "";
    message.password = object.password ?? "";
    message.emailVerificationRequestId = object.emailVerificationRequestId ?? "";
    message.emailVerificationOtp = object.emailVerificationOtp ?? "";
    message.deviceId = object.deviceId ?? "";
    return message;
  },
};

function createBaseForgetPasswordRequest(): ForgetPasswordRequest {
  return { email: "", newPassword: "", emailVerificationRequestId: "", emailVerificationOtp: "" };
}

export const ForgetPasswordRequest = {
  encode(message: ForgetPasswordRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.email !== "") {
      writer.uint32(10).string(message.email);
    }
    if (message.newPassword !== "") {
      writer.uint32(18).string(message.newPassword);
    }
    if (message.emailVerificationRequestId !== "") {
      writer.uint32(26).string(message.emailVerificationRequestId);
    }
    if (message.emailVerificationOtp !== "") {
      writer.uint32(34).string(message.emailVerificationOtp);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): ForgetPasswordRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseForgetPasswordRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.email = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.newPassword = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.emailVerificationRequestId = reader.string();
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.emailVerificationOtp = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ForgetPasswordRequest {
    return {
      email: isSet(object.email) ? globalThis.String(object.email) : "",
      newPassword: isSet(object.newPassword) ? globalThis.String(object.newPassword) : "",
      emailVerificationRequestId: isSet(object.emailVerificationRequestId)
        ? globalThis.String(object.emailVerificationRequestId)
        : "",
      emailVerificationOtp: isSet(object.emailVerificationOtp) ? globalThis.String(object.emailVerificationOtp) : "",
    };
  },

  toJSON(message: ForgetPasswordRequest): unknown {
    const obj: any = {};
    if (message.email !== "") {
      obj.email = message.email;
    }
    if (message.newPassword !== "") {
      obj.newPassword = message.newPassword;
    }
    if (message.emailVerificationRequestId !== "") {
      obj.emailVerificationRequestId = message.emailVerificationRequestId;
    }
    if (message.emailVerificationOtp !== "") {
      obj.emailVerificationOtp = message.emailVerificationOtp;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ForgetPasswordRequest>, I>>(base?: I): ForgetPasswordRequest {
    return ForgetPasswordRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ForgetPasswordRequest>, I>>(object: I): ForgetPasswordRequest {
    const message = createBaseForgetPasswordRequest();
    message.email = object.email ?? "";
    message.newPassword = object.newPassword ?? "";
    message.emailVerificationRequestId = object.emailVerificationRequestId ?? "";
    message.emailVerificationOtp = object.emailVerificationOtp ?? "";
    return message;
  },
};

function createBaseSendEmailOtpResponse(): SendEmailOtpResponse {
  return { requestId: "" };
}

export const SendEmailOtpResponse = {
  encode(message: SendEmailOtpResponse, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.requestId !== "") {
      writer.uint32(10).string(message.requestId);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SendEmailOtpResponse {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSendEmailOtpResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.requestId = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SendEmailOtpResponse {
    return { requestId: isSet(object.requestId) ? globalThis.String(object.requestId) : "" };
  },

  toJSON(message: SendEmailOtpResponse): unknown {
    const obj: any = {};
    if (message.requestId !== "") {
      obj.requestId = message.requestId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SendEmailOtpResponse>, I>>(base?: I): SendEmailOtpResponse {
    return SendEmailOtpResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SendEmailOtpResponse>, I>>(object: I): SendEmailOtpResponse {
    const message = createBaseSendEmailOtpResponse();
    message.requestId = object.requestId ?? "";
    return message;
  },
};

function createBaseVerifyEmailOtpRequest(): VerifyEmailOtpRequest {
  return { email: "", requestId: "", verificationOtp: "" };
}

export const VerifyEmailOtpRequest = {
  encode(message: VerifyEmailOtpRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.email !== "") {
      writer.uint32(10).string(message.email);
    }
    if (message.requestId !== "") {
      writer.uint32(18).string(message.requestId);
    }
    if (message.verificationOtp !== "") {
      writer.uint32(26).string(message.verificationOtp);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): VerifyEmailOtpRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseVerifyEmailOtpRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.email = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.requestId = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.verificationOtp = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): VerifyEmailOtpRequest {
    return {
      email: isSet(object.email) ? globalThis.String(object.email) : "",
      requestId: isSet(object.requestId) ? globalThis.String(object.requestId) : "",
      verificationOtp: isSet(object.verificationOtp) ? globalThis.String(object.verificationOtp) : "",
    };
  },

  toJSON(message: VerifyEmailOtpRequest): unknown {
    const obj: any = {};
    if (message.email !== "") {
      obj.email = message.email;
    }
    if (message.requestId !== "") {
      obj.requestId = message.requestId;
    }
    if (message.verificationOtp !== "") {
      obj.verificationOtp = message.verificationOtp;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<VerifyEmailOtpRequest>, I>>(base?: I): VerifyEmailOtpRequest {
    return VerifyEmailOtpRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<VerifyEmailOtpRequest>, I>>(object: I): VerifyEmailOtpRequest {
    const message = createBaseVerifyEmailOtpRequest();
    message.email = object.email ?? "";
    message.requestId = object.requestId ?? "";
    message.verificationOtp = object.verificationOtp ?? "";
    return message;
  },
};

function createBaseVerifyEmailOtpResponse(): VerifyEmailOtpResponse {
  return { successful: false };
}

export const VerifyEmailOtpResponse = {
  encode(message: VerifyEmailOtpResponse, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.successful !== false) {
      writer.uint32(8).bool(message.successful);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): VerifyEmailOtpResponse {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseVerifyEmailOtpResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.successful = reader.bool();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): VerifyEmailOtpResponse {
    return { successful: isSet(object.successful) ? globalThis.Boolean(object.successful) : false };
  },

  toJSON(message: VerifyEmailOtpResponse): unknown {
    const obj: any = {};
    if (message.successful !== false) {
      obj.successful = message.successful;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<VerifyEmailOtpResponse>, I>>(base?: I): VerifyEmailOtpResponse {
    return VerifyEmailOtpResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<VerifyEmailOtpResponse>, I>>(object: I): VerifyEmailOtpResponse {
    const message = createBaseVerifyEmailOtpResponse();
    message.successful = object.successful ?? false;
    return message;
  },
};

function createBaseChangeEmailRequest(): ChangeEmailRequest {
  return { newEmail: "", pin: "" };
}

export const ChangeEmailRequest = {
  encode(message: ChangeEmailRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.newEmail !== "") {
      writer.uint32(10).string(message.newEmail);
    }
    if (message.pin !== "") {
      writer.uint32(18).string(message.pin);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): ChangeEmailRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseChangeEmailRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.newEmail = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.pin = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ChangeEmailRequest {
    return {
      newEmail: isSet(object.newEmail) ? globalThis.String(object.newEmail) : "",
      pin: isSet(object.pin) ? globalThis.String(object.pin) : "",
    };
  },

  toJSON(message: ChangeEmailRequest): unknown {
    const obj: any = {};
    if (message.newEmail !== "") {
      obj.newEmail = message.newEmail;
    }
    if (message.pin !== "") {
      obj.pin = message.pin;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ChangeEmailRequest>, I>>(base?: I): ChangeEmailRequest {
    return ChangeEmailRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ChangeEmailRequest>, I>>(object: I): ChangeEmailRequest {
    const message = createBaseChangeEmailRequest();
    message.newEmail = object.newEmail ?? "";
    message.pin = object.pin ?? "";
    return message;
  },
};

function createBaseVerifyEmailChangeRequest(): VerifyEmailChangeRequest {
  return { newEmail: "", requestId: "", verificationOtp: "" };
}

export const VerifyEmailChangeRequest = {
  encode(message: VerifyEmailChangeRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.newEmail !== "") {
      writer.uint32(10).string(message.newEmail);
    }
    if (message.requestId !== "") {
      writer.uint32(18).string(message.requestId);
    }
    if (message.verificationOtp !== "") {
      writer.uint32(26).string(message.verificationOtp);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): VerifyEmailChangeRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseVerifyEmailChangeRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.newEmail = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.requestId = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.verificationOtp = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): VerifyEmailChangeRequest {
    return {
      newEmail: isSet(object.newEmail) ? globalThis.String(object.newEmail) : "",
      requestId: isSet(object.requestId) ? globalThis.String(object.requestId) : "",
      verificationOtp: isSet(object.verificationOtp) ? globalThis.String(object.verificationOtp) : "",
    };
  },

  toJSON(message: VerifyEmailChangeRequest): unknown {
    const obj: any = {};
    if (message.newEmail !== "") {
      obj.newEmail = message.newEmail;
    }
    if (message.requestId !== "") {
      obj.requestId = message.requestId;
    }
    if (message.verificationOtp !== "") {
      obj.verificationOtp = message.verificationOtp;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<VerifyEmailChangeRequest>, I>>(base?: I): VerifyEmailChangeRequest {
    return VerifyEmailChangeRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<VerifyEmailChangeRequest>, I>>(object: I): VerifyEmailChangeRequest {
    const message = createBaseVerifyEmailChangeRequest();
    message.newEmail = object.newEmail ?? "";
    message.requestId = object.requestId ?? "";
    message.verificationOtp = object.verificationOtp ?? "";
    return message;
  },
};

function createBaseLoginRequest(): LoginRequest {
  return { email: "", password: "", deviceId: "", deviceInfo: "" };
}

export const LoginRequest = {
  encode(message: LoginRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.email !== "") {
      writer.uint32(10).string(message.email);
    }
    if (message.password !== "") {
      writer.uint32(18).string(message.password);
    }
    if (message.deviceId !== "") {
      writer.uint32(26).string(message.deviceId);
    }
    if (message.deviceInfo !== "") {
      writer.uint32(34).string(message.deviceInfo);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): LoginRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseLoginRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.email = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.password = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.deviceId = reader.string();
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.deviceInfo = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): LoginRequest {
    return {
      email: isSet(object.email) ? globalThis.String(object.email) : "",
      password: isSet(object.password) ? globalThis.String(object.password) : "",
      deviceId: isSet(object.deviceId) ? globalThis.String(object.deviceId) : "",
      deviceInfo: isSet(object.deviceInfo) ? globalThis.String(object.deviceInfo) : "",
    };
  },

  toJSON(message: LoginRequest): unknown {
    const obj: any = {};
    if (message.email !== "") {
      obj.email = message.email;
    }
    if (message.password !== "") {
      obj.password = message.password;
    }
    if (message.deviceId !== "") {
      obj.deviceId = message.deviceId;
    }
    if (message.deviceInfo !== "") {
      obj.deviceInfo = message.deviceInfo;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<LoginRequest>, I>>(base?: I): LoginRequest {
    return LoginRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<LoginRequest>, I>>(object: I): LoginRequest {
    const message = createBaseLoginRequest();
    message.email = object.email ?? "";
    message.password = object.password ?? "";
    message.deviceId = object.deviceId ?? "";
    message.deviceInfo = object.deviceInfo ?? "";
    return message;
  },
};

function createBaseLoginWithMobileRequest(): LoginWithMobileRequest {
  return { mobile: "" };
}

export const LoginWithMobileRequest = {
  encode(message: LoginWithMobileRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.mobile !== "") {
      writer.uint32(10).string(message.mobile);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): LoginWithMobileRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseLoginWithMobileRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.mobile = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): LoginWithMobileRequest {
    return { mobile: isSet(object.mobile) ? globalThis.String(object.mobile) : "" };
  },

  toJSON(message: LoginWithMobileRequest): unknown {
    const obj: any = {};
    if (message.mobile !== "") {
      obj.mobile = message.mobile;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<LoginWithMobileRequest>, I>>(base?: I): LoginWithMobileRequest {
    return LoginWithMobileRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<LoginWithMobileRequest>, I>>(object: I): LoginWithMobileRequest {
    const message = createBaseLoginWithMobileRequest();
    message.mobile = object.mobile ?? "";
    return message;
  },
};

function createBaseLoginWithMobileResponse(): LoginWithMobileResponse {
  return { requestId: "" };
}

export const LoginWithMobileResponse = {
  encode(message: LoginWithMobileResponse, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.requestId !== "") {
      writer.uint32(10).string(message.requestId);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): LoginWithMobileResponse {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseLoginWithMobileResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.requestId = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): LoginWithMobileResponse {
    return { requestId: isSet(object.requestId) ? globalThis.String(object.requestId) : "" };
  },

  toJSON(message: LoginWithMobileResponse): unknown {
    const obj: any = {};
    if (message.requestId !== "") {
      obj.requestId = message.requestId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<LoginWithMobileResponse>, I>>(base?: I): LoginWithMobileResponse {
    return LoginWithMobileResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<LoginWithMobileResponse>, I>>(object: I): LoginWithMobileResponse {
    const message = createBaseLoginWithMobileResponse();
    message.requestId = object.requestId ?? "";
    return message;
  },
};

function createBaseVerifyMobileLoginRequest(): VerifyMobileLoginRequest {
  return { mobile: "", requestId: "", verificationOtp: "", deviceId: "", deviceInfo: "" };
}

export const VerifyMobileLoginRequest = {
  encode(message: VerifyMobileLoginRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.mobile !== "") {
      writer.uint32(10).string(message.mobile);
    }
    if (message.requestId !== "") {
      writer.uint32(18).string(message.requestId);
    }
    if (message.verificationOtp !== "") {
      writer.uint32(26).string(message.verificationOtp);
    }
    if (message.deviceId !== "") {
      writer.uint32(34).string(message.deviceId);
    }
    if (message.deviceInfo !== "") {
      writer.uint32(42).string(message.deviceInfo);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): VerifyMobileLoginRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseVerifyMobileLoginRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.mobile = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.requestId = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.verificationOtp = reader.string();
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.deviceId = reader.string();
          continue;
        case 5:
          if (tag !== 42) {
            break;
          }

          message.deviceInfo = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): VerifyMobileLoginRequest {
    return {
      mobile: isSet(object.mobile) ? globalThis.String(object.mobile) : "",
      requestId: isSet(object.requestId) ? globalThis.String(object.requestId) : "",
      verificationOtp: isSet(object.verificationOtp) ? globalThis.String(object.verificationOtp) : "",
      deviceId: isSet(object.deviceId) ? globalThis.String(object.deviceId) : "",
      deviceInfo: isSet(object.deviceInfo) ? globalThis.String(object.deviceInfo) : "",
    };
  },

  toJSON(message: VerifyMobileLoginRequest): unknown {
    const obj: any = {};
    if (message.mobile !== "") {
      obj.mobile = message.mobile;
    }
    if (message.requestId !== "") {
      obj.requestId = message.requestId;
    }
    if (message.verificationOtp !== "") {
      obj.verificationOtp = message.verificationOtp;
    }
    if (message.deviceId !== "") {
      obj.deviceId = message.deviceId;
    }
    if (message.deviceInfo !== "") {
      obj.deviceInfo = message.deviceInfo;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<VerifyMobileLoginRequest>, I>>(base?: I): VerifyMobileLoginRequest {
    return VerifyMobileLoginRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<VerifyMobileLoginRequest>, I>>(object: I): VerifyMobileLoginRequest {
    const message = createBaseVerifyMobileLoginRequest();
    message.mobile = object.mobile ?? "";
    message.requestId = object.requestId ?? "";
    message.verificationOtp = object.verificationOtp ?? "";
    message.deviceId = object.deviceId ?? "";
    message.deviceInfo = object.deviceInfo ?? "";
    return message;
  },
};

function createBaseLoginResponse(): LoginResponse {
  return { accessToken: "", tokenType: "", isNewUser: undefined, refreshToken: "" };
}

export const LoginResponse = {
  encode(message: LoginResponse, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.accessToken !== "") {
      writer.uint32(10).string(message.accessToken);
    }
    if (message.tokenType !== "") {
      writer.uint32(18).string(message.tokenType);
    }
    if (message.isNewUser !== undefined) {
      writer.uint32(32).bool(message.isNewUser);
    }
    if (message.refreshToken !== "") {
      writer.uint32(50).string(message.refreshToken);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): LoginResponse {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseLoginResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.accessToken = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.tokenType = reader.string();
          continue;
        case 4:
          if (tag !== 32) {
            break;
          }

          message.isNewUser = reader.bool();
          continue;
        case 6:
          if (tag !== 50) {
            break;
          }

          message.refreshToken = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): LoginResponse {
    return {
      accessToken: isSet(object.accessToken) ? globalThis.String(object.accessToken) : "",
      tokenType: isSet(object.tokenType) ? globalThis.String(object.tokenType) : "",
      isNewUser: isSet(object.isNewUser) ? globalThis.Boolean(object.isNewUser) : undefined,
      refreshToken: isSet(object.refreshToken) ? globalThis.String(object.refreshToken) : "",
    };
  },

  toJSON(message: LoginResponse): unknown {
    const obj: any = {};
    if (message.accessToken !== "") {
      obj.accessToken = message.accessToken;
    }
    if (message.tokenType !== "") {
      obj.tokenType = message.tokenType;
    }
    if (message.isNewUser !== undefined) {
      obj.isNewUser = message.isNewUser;
    }
    if (message.refreshToken !== "") {
      obj.refreshToken = message.refreshToken;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<LoginResponse>, I>>(base?: I): LoginResponse {
    return LoginResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<LoginResponse>, I>>(object: I): LoginResponse {
    const message = createBaseLoginResponse();
    message.accessToken = object.accessToken ?? "";
    message.tokenType = object.tokenType ?? "";
    message.isNewUser = object.isNewUser ?? undefined;
    message.refreshToken = object.refreshToken ?? "";
    return message;
  },
};

function createBaseSessionRequest(): SessionRequest {
  return { refreshToken: "", deviceId: "", deviceInfo: "" };
}

export const SessionRequest = {
  encode(message: SessionRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.refreshToken !== "") {
      writer.uint32(10).string(message.refreshToken);
    }
    if (message.deviceId !== "") {
      writer.uint32(18).string(message.deviceId);
    }
    if (message.deviceInfo !== "") {
      writer.uint32(26).string(message.deviceInfo);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SessionRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSessionRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.refreshToken = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.deviceId = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.deviceInfo = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SessionRequest {
    return {
      refreshToken: isSet(object.refreshToken) ? globalThis.String(object.refreshToken) : "",
      deviceId: isSet(object.deviceId) ? globalThis.String(object.deviceId) : "",
      deviceInfo: isSet(object.deviceInfo) ? globalThis.String(object.deviceInfo) : "",
    };
  },

  toJSON(message: SessionRequest): unknown {
    const obj: any = {};
    if (message.refreshToken !== "") {
      obj.refreshToken = message.refreshToken;
    }
    if (message.deviceId !== "") {
      obj.deviceId = message.deviceId;
    }
    if (message.deviceInfo !== "") {
      obj.deviceInfo = message.deviceInfo;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SessionRequest>, I>>(base?: I): SessionRequest {
    return SessionRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SessionRequest>, I>>(object: I): SessionRequest {
    const message = createBaseSessionRequest();
    message.refreshToken = object.refreshToken ?? "";
    message.deviceId = object.deviceId ?? "";
    message.deviceInfo = object.deviceInfo ?? "";
    return message;
  },
};

function createBaseRefreshTokenResponse(): RefreshTokenResponse {
  return { accessToken: "", tokenType: "" };
}

export const RefreshTokenResponse = {
  encode(message: RefreshTokenResponse, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.accessToken !== "") {
      writer.uint32(10).string(message.accessToken);
    }
    if (message.tokenType !== "") {
      writer.uint32(18).string(message.tokenType);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): RefreshTokenResponse {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRefreshTokenResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.accessToken = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.tokenType = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RefreshTokenResponse {
    return {
      accessToken: isSet(object.accessToken) ? globalThis.String(object.accessToken) : "",
      tokenType: isSet(object.tokenType) ? globalThis.String(object.tokenType) : "",
    };
  },

  toJSON(message: RefreshTokenResponse): unknown {
    const obj: any = {};
    if (message.accessToken !== "") {
      obj.accessToken = message.accessToken;
    }
    if (message.tokenType !== "") {
      obj.tokenType = message.tokenType;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<RefreshTokenResponse>, I>>(base?: I): RefreshTokenResponse {
    return RefreshTokenResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RefreshTokenResponse>, I>>(object: I): RefreshTokenResponse {
    const message = createBaseRefreshTokenResponse();
    message.accessToken = object.accessToken ?? "";
    message.tokenType = object.tokenType ?? "";
    return message;
  },
};

function createBaseOperationResponse(): OperationResponse {
  return { success: false, message: "", accessToken: "" };
}

export const OperationResponse = {
  encode(message: OperationResponse, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.success !== false) {
      writer.uint32(8).bool(message.success);
    }
    if (message.message !== "") {
      writer.uint32(18).string(message.message);
    }
    if (message.accessToken !== "") {
      writer.uint32(26).string(message.accessToken);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): OperationResponse {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseOperationResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.success = reader.bool();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.message = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.accessToken = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): OperationResponse {
    return {
      success: isSet(object.success) ? globalThis.Boolean(object.success) : false,
      message: isSet(object.message) ? globalThis.String(object.message) : "",
      accessToken: isSet(object.accessToken) ? globalThis.String(object.accessToken) : "",
    };
  },

  toJSON(message: OperationResponse): unknown {
    const obj: any = {};
    if (message.success !== false) {
      obj.success = message.success;
    }
    if (message.message !== "") {
      obj.message = message.message;
    }
    if (message.accessToken !== "") {
      obj.accessToken = message.accessToken;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<OperationResponse>, I>>(base?: I): OperationResponse {
    return OperationResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<OperationResponse>, I>>(object: I): OperationResponse {
    const message = createBaseOperationResponse();
    message.success = object.success ?? false;
    message.message = object.message ?? "";
    message.accessToken = object.accessToken ?? "";
    return message;
  },
};

function createBaseUserSession(): UserSession {
  return { deviceId: "", lastUsedAt: "", deviceInfo: "" };
}

export const UserSession = {
  encode(message: UserSession, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.deviceId !== "") {
      writer.uint32(10).string(message.deviceId);
    }
    if (message.lastUsedAt !== "") {
      writer.uint32(18).string(message.lastUsedAt);
    }
    if (message.deviceInfo !== "") {
      writer.uint32(26).string(message.deviceInfo);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): UserSession {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUserSession();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.deviceId = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.lastUsedAt = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.deviceInfo = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UserSession {
    return {
      deviceId: isSet(object.deviceId) ? globalThis.String(object.deviceId) : "",
      lastUsedAt: isSet(object.lastUsedAt) ? globalThis.String(object.lastUsedAt) : "",
      deviceInfo: isSet(object.deviceInfo) ? globalThis.String(object.deviceInfo) : "",
    };
  },

  toJSON(message: UserSession): unknown {
    const obj: any = {};
    if (message.deviceId !== "") {
      obj.deviceId = message.deviceId;
    }
    if (message.lastUsedAt !== "") {
      obj.lastUsedAt = message.lastUsedAt;
    }
    if (message.deviceInfo !== "") {
      obj.deviceInfo = message.deviceInfo;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UserSession>, I>>(base?: I): UserSession {
    return UserSession.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UserSession>, I>>(object: I): UserSession {
    const message = createBaseUserSession();
    message.deviceId = object.deviceId ?? "";
    message.lastUsedAt = object.lastUsedAt ?? "";
    message.deviceInfo = object.deviceInfo ?? "";
    return message;
  },
};

function createBaseGetActiveSessionsResponse(): GetActiveSessionsResponse {
  return { sessions: [] };
}

export const GetActiveSessionsResponse = {
  encode(message: GetActiveSessionsResponse, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    for (const v of message.sessions) {
      UserSession.encode(v!, writer.uint32(10).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): GetActiveSessionsResponse {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetActiveSessionsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.sessions.push(UserSession.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetActiveSessionsResponse {
    return {
      sessions: globalThis.Array.isArray(object?.sessions)
        ? object.sessions.map((e: any) => UserSession.fromJSON(e))
        : [],
    };
  },

  toJSON(message: GetActiveSessionsResponse): unknown {
    const obj: any = {};
    if (message.sessions?.length) {
      obj.sessions = message.sessions.map((e) => UserSession.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetActiveSessionsResponse>, I>>(base?: I): GetActiveSessionsResponse {
    return GetActiveSessionsResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetActiveSessionsResponse>, I>>(object: I): GetActiveSessionsResponse {
    const message = createBaseGetActiveSessionsResponse();
    message.sessions = object.sessions?.map((e) => UserSession.fromPartial(e)) || [];
    return message;
  },
};

function createBaseRevokeSessionRequest(): RevokeSessionRequest {
  return { deviceId: "" };
}

export const RevokeSessionRequest = {
  encode(message: RevokeSessionRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.deviceId !== "") {
      writer.uint32(10).string(message.deviceId);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): RevokeSessionRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRevokeSessionRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.deviceId = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RevokeSessionRequest {
    return { deviceId: isSet(object.deviceId) ? globalThis.String(object.deviceId) : "" };
  },

  toJSON(message: RevokeSessionRequest): unknown {
    const obj: any = {};
    if (message.deviceId !== "") {
      obj.deviceId = message.deviceId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<RevokeSessionRequest>, I>>(base?: I): RevokeSessionRequest {
    return RevokeSessionRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RevokeSessionRequest>, I>>(object: I): RevokeSessionRequest {
    const message = createBaseRevokeSessionRequest();
    message.deviceId = object.deviceId ?? "";
    return message;
  },
};

function createBaseSendPinVerificationOtpRequest(): SendPinVerificationOtpRequest {
  return { channel: 0 };
}

export const SendPinVerificationOtpRequest = {
  encode(message: SendPinVerificationOtpRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.channel !== 0) {
      writer.uint32(8).int32(message.channel);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SendPinVerificationOtpRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSendPinVerificationOtpRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.channel = reader.int32() as any;
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SendPinVerificationOtpRequest {
    return { channel: isSet(object.channel) ? pinVerificationChannelFromJSON(object.channel) : 0 };
  },

  toJSON(message: SendPinVerificationOtpRequest): unknown {
    const obj: any = {};
    if (message.channel !== 0) {
      obj.channel = pinVerificationChannelToJSON(message.channel);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SendPinVerificationOtpRequest>, I>>(base?: I): SendPinVerificationOtpRequest {
    return SendPinVerificationOtpRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SendPinVerificationOtpRequest>, I>>(
    object: I,
  ): SendPinVerificationOtpRequest {
    const message = createBaseSendPinVerificationOtpRequest();
    message.channel = object.channel ?? 0;
    return message;
  },
};

function createBaseSendPinVerificationOtpResponse(): SendPinVerificationOtpResponse {
  return { requestId: "" };
}

export const SendPinVerificationOtpResponse = {
  encode(message: SendPinVerificationOtpResponse, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.requestId !== "") {
      writer.uint32(10).string(message.requestId);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SendPinVerificationOtpResponse {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSendPinVerificationOtpResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.requestId = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SendPinVerificationOtpResponse {
    return { requestId: isSet(object.requestId) ? globalThis.String(object.requestId) : "" };
  },

  toJSON(message: SendPinVerificationOtpResponse): unknown {
    const obj: any = {};
    if (message.requestId !== "") {
      obj.requestId = message.requestId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SendPinVerificationOtpResponse>, I>>(base?: I): SendPinVerificationOtpResponse {
    return SendPinVerificationOtpResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SendPinVerificationOtpResponse>, I>>(
    object: I,
  ): SendPinVerificationOtpResponse {
    const message = createBaseSendPinVerificationOtpResponse();
    message.requestId = object.requestId ?? "";
    return message;
  },
};

function createBaseSetPinRequest(): SetPinRequest {
  return { pin: "", verificationRequestId: "", verificationOtp: "", pinSetupToken: "" };
}

export const SetPinRequest = {
  encode(message: SetPinRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.pin !== "") {
      writer.uint32(10).string(message.pin);
    }
    if (message.verificationRequestId !== "") {
      writer.uint32(18).string(message.verificationRequestId);
    }
    if (message.verificationOtp !== "") {
      writer.uint32(26).string(message.verificationOtp);
    }
    if (message.pinSetupToken !== "") {
      writer.uint32(34).string(message.pinSetupToken);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SetPinRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSetPinRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.pin = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.verificationRequestId = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.verificationOtp = reader.string();
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.pinSetupToken = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SetPinRequest {
    return {
      pin: isSet(object.pin) ? globalThis.String(object.pin) : "",
      verificationRequestId: isSet(object.verificationRequestId) ? globalThis.String(object.verificationRequestId) : "",
      verificationOtp: isSet(object.verificationOtp) ? globalThis.String(object.verificationOtp) : "",
      pinSetupToken: isSet(object.pinSetupToken) ? globalThis.String(object.pinSetupToken) : "",
    };
  },

  toJSON(message: SetPinRequest): unknown {
    const obj: any = {};
    if (message.pin !== "") {
      obj.pin = message.pin;
    }
    if (message.verificationRequestId !== "") {
      obj.verificationRequestId = message.verificationRequestId;
    }
    if (message.verificationOtp !== "") {
      obj.verificationOtp = message.verificationOtp;
    }
    if (message.pinSetupToken !== "") {
      obj.pinSetupToken = message.pinSetupToken;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SetPinRequest>, I>>(base?: I): SetPinRequest {
    return SetPinRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SetPinRequest>, I>>(object: I): SetPinRequest {
    const message = createBaseSetPinRequest();
    message.pin = object.pin ?? "";
    message.verificationRequestId = object.verificationRequestId ?? "";
    message.verificationOtp = object.verificationOtp ?? "";
    message.pinSetupToken = object.pinSetupToken ?? "";
    return message;
  },
};

function createBaseVerifyPinRequest(): VerifyPinRequest {
  return { pin: "" };
}

export const VerifyPinRequest = {
  encode(message: VerifyPinRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.pin !== "") {
      writer.uint32(10).string(message.pin);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): VerifyPinRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseVerifyPinRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.pin = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): VerifyPinRequest {
    return { pin: isSet(object.pin) ? globalThis.String(object.pin) : "" };
  },

  toJSON(message: VerifyPinRequest): unknown {
    const obj: any = {};
    if (message.pin !== "") {
      obj.pin = message.pin;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<VerifyPinRequest>, I>>(base?: I): VerifyPinRequest {
    return VerifyPinRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<VerifyPinRequest>, I>>(object: I): VerifyPinRequest {
    const message = createBaseVerifyPinRequest();
    message.pin = object.pin ?? "";
    return message;
  },
};

function createBaseRemovePinRequest(): RemovePinRequest {
  return { verificationRequestId: "", verificationOtp: "" };
}

export const RemovePinRequest = {
  encode(message: RemovePinRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.verificationRequestId !== "") {
      writer.uint32(10).string(message.verificationRequestId);
    }
    if (message.verificationOtp !== "") {
      writer.uint32(18).string(message.verificationOtp);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): RemovePinRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRemovePinRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.verificationRequestId = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.verificationOtp = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RemovePinRequest {
    return {
      verificationRequestId: isSet(object.verificationRequestId) ? globalThis.String(object.verificationRequestId) : "",
      verificationOtp: isSet(object.verificationOtp) ? globalThis.String(object.verificationOtp) : "",
    };
  },

  toJSON(message: RemovePinRequest): unknown {
    const obj: any = {};
    if (message.verificationRequestId !== "") {
      obj.verificationRequestId = message.verificationRequestId;
    }
    if (message.verificationOtp !== "") {
      obj.verificationOtp = message.verificationOtp;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<RemovePinRequest>, I>>(base?: I): RemovePinRequest {
    return RemovePinRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RemovePinRequest>, I>>(object: I): RemovePinRequest {
    const message = createBaseRemovePinRequest();
    message.verificationRequestId = object.verificationRequestId ?? "";
    message.verificationOtp = object.verificationOtp ?? "";
    return message;
  },
};

function createBaseSendForgotPinOtpResponse(): SendForgotPinOtpResponse {
  return { requestId: "" };
}

export const SendForgotPinOtpResponse = {
  encode(message: SendForgotPinOtpResponse, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.requestId !== "") {
      writer.uint32(10).string(message.requestId);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SendForgotPinOtpResponse {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSendForgotPinOtpResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.requestId = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SendForgotPinOtpResponse {
    return { requestId: isSet(object.requestId) ? globalThis.String(object.requestId) : "" };
  },

  toJSON(message: SendForgotPinOtpResponse): unknown {
    const obj: any = {};
    if (message.requestId !== "") {
      obj.requestId = message.requestId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SendForgotPinOtpResponse>, I>>(base?: I): SendForgotPinOtpResponse {
    return SendForgotPinOtpResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SendForgotPinOtpResponse>, I>>(object: I): SendForgotPinOtpResponse {
    const message = createBaseSendForgotPinOtpResponse();
    message.requestId = object.requestId ?? "";
    return message;
  },
};

function createBaseForgotPinRequest(): ForgotPinRequest {
  return { newPin: "", verificationRequestId: "", verificationOtp: "" };
}

export const ForgotPinRequest = {
  encode(message: ForgotPinRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.newPin !== "") {
      writer.uint32(10).string(message.newPin);
    }
    if (message.verificationRequestId !== "") {
      writer.uint32(18).string(message.verificationRequestId);
    }
    if (message.verificationOtp !== "") {
      writer.uint32(26).string(message.verificationOtp);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): ForgotPinRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseForgotPinRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.newPin = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.verificationRequestId = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.verificationOtp = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ForgotPinRequest {
    return {
      newPin: isSet(object.newPin) ? globalThis.String(object.newPin) : "",
      verificationRequestId: isSet(object.verificationRequestId) ? globalThis.String(object.verificationRequestId) : "",
      verificationOtp: isSet(object.verificationOtp) ? globalThis.String(object.verificationOtp) : "",
    };
  },

  toJSON(message: ForgotPinRequest): unknown {
    const obj: any = {};
    if (message.newPin !== "") {
      obj.newPin = message.newPin;
    }
    if (message.verificationRequestId !== "") {
      obj.verificationRequestId = message.verificationRequestId;
    }
    if (message.verificationOtp !== "") {
      obj.verificationOtp = message.verificationOtp;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ForgotPinRequest>, I>>(base?: I): ForgotPinRequest {
    return ForgotPinRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ForgotPinRequest>, I>>(object: I): ForgotPinRequest {
    const message = createBaseForgotPinRequest();
    message.newPin = object.newPin ?? "";
    message.verificationRequestId = object.verificationRequestId ?? "";
    message.verificationOtp = object.verificationOtp ?? "";
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
